import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import UTCheckbox from '../UTCheckbox';

import stylesJS from './styles';
import styles from './styles.module.scss';

class UTCheckRow extends PureComponent {
  getItemKeys = item =>
    Object.keys(item).filter(key => (this.props.userForm ? key === 'name' : key !== 'id'));

  handleOnChange = () => {
    this.props.onChange(this.props.userForm ? this.props.item.value : this.props.item.id);
  };

  render() {
    return (
      <div key={this.props.item.id} style={stylesJS.row}>
        {this.getItemKeys(this.props.item).map(key => (
          <div className={styles.headerItem} key={this.props.item[key]}>
            <UTLabel style={stylesJS.rowItem} small>
              {this.props.item[key]}
            </UTLabel>
          </div>
        ))}
        <div>
          <UTCheckbox value={this.props.value} onChange={this.handleOnChange} />
        </div>
      </div>
    );
  }
}

UTCheckRow.propTypes = {
  onChange: PropTypes.func,
  item: PropTypes.shape({
    id: PropTypes.number,
    client_number: PropTypes.string,
    address: PropTypes.string,
    value: PropTypes.string
  }),
  value: PropTypes.bool,
  userForm: PropTypes.bool
};

export default UTCheckRow;
